export default __webpack_public_path__ + "media/images/mailer-new/heading/login-b7724c2ce8ccb14cf64dea3e36ac3e32.png";